import { createContext, useContext } from 'react';
"use strict";
const ScrollGroupContext = createContext(null);
function useScrollGroupContext() {
  const contextValue = useContext(ScrollGroupContext);
  if (!contextValue) {
    throw new Error("Please wrap this component in <ScrollGroup />");
  }
  return contextValue;
}
export { ScrollGroupContext, useScrollGroupContext };
//# sourceMappingURL=context.mjs.map
